<template>
  <el-dialog :visible="visible" :title="$t('selectStaff.title')" width="80%" @close="handleClose">
    <el-row :gutter="20">
      <el-col :span="12" class="border-right">
        <div class="text-center">
          <h4>{{ $t('selectStaff.orgInfo') }}</h4>
        </div>
        <div class="staff padding">
          <OrgTreeShow ref="orgTree" @org-selected="handleOrgSelected" />
        </div>
      </el-col>
      <el-col :span="12">
        <div class="text-center">
          <h4>{{ $t('selectStaff.staffInfo') }}</h4>
        </div>
        <div class="padding-left staff padding padding-top-xs">
          <div v-for="(item, index) in staffs" :key="index" class="staff-item" 
          :class="{'selected': curStaffId == item.userId }" @click="selectStaff(item)">
            <div>
              <i class="el-icon-user margin-right-xs"></i>
              {{ item.name }}
            </div>
            <div>{{ item.tel }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import OrgTreeShow from '@/components/org/OrgTreeShow'
import { getStaffInfos } from '@/api/work/repairTypeUserApi'
import { queryStaffInCommunity, listStaffByOrg } from '@/api/oa/addWorkApi'

export default {
  name: 'SelectStaff',
  components: {
    OrgTreeShow
  },
  data() {
    return {
      visible: false,
      staffs: [],
      curStaffId: '',
      selectedStaff: null,
      staffConfig: {},
      currentOrgId: '',
      userOrgId: '',
      userOrgIds: [],
      communityId: '',
      userRole: 'normal',
      showOtherDeptStaff: true,
      adminMode: false
    }
  },
  methods: {
    open: function (config) {
      if (!config) config = {}
      this.userOrgId = config.currentOrgId || ''
      this.userOrgIds = config.userOrgIds || []
      this.communityId = config.communityId || ''
      this.userRole = config.userRole || 'normal'
      this.showOtherDeptStaff = config.showOtherDeptStaff !== false
      this.adminMode = config.adminMode || false
      this.visible = true
      var self = this
      this.$nextTick(function () {
        self.$refs.orgTree.refreshTree()
      })
    },
    handleClose: function () {
      this.visible = false
      this.staffs = []
      this.curStaffId = ''
      this.selectedStaff = null
    },
    handleOrgSelected: function (org) {
      this.currentOrgId = org.orgId
      this.loadStaff(org.orgId)
    },
    loadStaff: function (orgId) {
      var self = this
      try {
        var params = {
          orgId: orgId,
          row: 50,
          page: 1
        }

        // 管理模式：绕过所有角色过滤，直接显示全部员工
        if (self.adminMode) {
          listStaffByOrg(params).then(function (res) {
            var allStaff = res.staffs || []
            self.staffs = allStaff
            if (self.staffs.length > 0) {
              self.curStaffId = self.staffs[0].userId
              self.selectedStaff = self.staffs[0]
            }
          }).catch(function (error) {
            console.error('Error loading staff:', error)
            self.$message.error(self.$t('common.requestFailed'))
          })
          return
        }

        var isOwnDept = false
        if (self.userOrgIds && self.userOrgIds.length > 0) {
          // 判断 orgId 是否在用户的所有部门中
          var strOrgId = String(orgId)
          for (var ii = 0; ii < self.userOrgIds.length; ii++) {
            if (String(self.userOrgIds[ii]) === strOrgId) {
              isOwnDept = true
              break
            }
          }
        }
        if (!isOwnDept && self.userOrgId !== '') {
          isOwnDept = (String(orgId) === String(self.userOrgId))
        }
        if (self.userRole === 'normal' && !isOwnDept) {
          self.staffs = []
          return
        }

        var queryFunc = getStaffInfos
        if (self.communityId && (self.userRole === 'supervisor' || self.userRole === 'supervisor_manager')) {
          queryFunc = queryStaffInCommunity
          params.communityId = self.communityId
        }

        queryFunc(params).then(function (res) {
          var staffs = res.staffs || []

          if (self.userRole === 'manager') {
            if (isOwnDept) {
              var mgrParams = { orgId: orgId, row: 50, page: 1 }
              listStaffByOrg(mgrParams).then(function (mgrRes) {
                var allStaff = mgrRes.staffs || []
                self.staffs = allStaff
                if (self.staffs.length > 0) {
                  self.curStaffId = self.staffs[0].userId
                  self.selectedStaff = self.staffs[0]
                }
              }).catch(function (error) {
                console.error('Error loading staff:', error)
                self.$message.error(self.$t('common.requestFailed'))
              })
              return
            } else {
              // Manager 点其他部门：根据 showOtherDeptStaff 决定是否显示
              if (!self.showOtherDeptStaff) {
                self.staffs = []
                return
              }
              
              var hasManager = false
              var maxRelCd = 0
              var managers = []
              var i, s, rc, numRc
              
              for (i = 0; i < staffs.length; i++) {
                s = staffs[i]
                rc = s.relCd || s.rel_cd
                if (!rc || rc === '1000' || rc === '600311000001' || rc === '600311000002') continue
                numRc = parseInt(rc) || 0
                if (numRc > maxRelCd) {
                  maxRelCd = numRc
                }
              }
              
              if (maxRelCd > 0) {
                hasManager = true
                for (i = 0; i < staffs.length; i++) {
                  s = staffs[i]
                  rc = s.relCd || s.rel_cd
                  if (rc && (parseInt(rc) || 0) === maxRelCd) {
                    managers.push(s)
                  }
                }
              }
              
              self.staffs = hasManager ? managers : staffs
            }

          } else if (self.userRole === 'normal') {
            self.staffs = staffs

          } else {
            self.staffs = staffs
          }
          
          if (self.staffs.length > 0) {
            self.curStaffId = self.staffs[0].userId
            self.selectedStaff = self.staffs[0]
          }
        }).catch(function (error) {
          console.error('Error loading staff:', error)
          self.$message.error(self.$t('common.requestFailed'))
        })
      } catch (error) {
        console.error('Error loading staff:', error)
        self.$message.error(self.$t('common.requestFailed'))
      }
    },
    selectStaff: function (staff) {
      this.curStaffId = staff.userId
      this.selectedStaff = staff
    },
    handleSubmit: function () {
      if (this.selectedStaff) {
        this.selectedStaff.staffId = this.selectedStaff.userId
        this.selectedStaff.staffName = this.selectedStaff.userName
        this.$emit('selectStaff', this.selectedStaff)
        this.handleClose()
      } else {
        this.$message.warning(this.$t('selectStaff.selectStaffFirst'))
      }
    }
  }
}
</script>

<style scoped>
.border-right {
  border-right: 1px solid #ebeef5;
}

.padding {
  padding: 15px;
}

.staff-item {
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  cursor: pointer;
}

.staff-item:hover {
  background-color: #f5f7fa;
}

.selected {
  background-color: #ecf5ff;
  border: 1px solid #409eff;
}

.text-center {
  text-align: center;
  margin-bottom: 15px;
}
</style>
